import { observable, action, computed } from 'mobx';
import { makeApi, URLS } from 'Utils/apiUtil';
import { loginValidate, myLeadsList } from 'Utils/commonApi';
import * as CONSTANTS from 'Utils/constants';
import { Utils } from 'Utils/utils';
import { toasterState } from 'Components/common/toaster';
import { purchaseStatusPopupState } from 'Components/common/purchaseStatusPopup';
import { userDetail } from './userDetail';
import { advSearchState } from './advSearch';

const {
  CONTACT_PURCHASE_TYPES,
  CONTACT_EXPORT_TYPES,
  MX_ML_EVENTS,
} = CONSTANTS;

const { DIRECT_PURCHASE } = CONTACT_PURCHASE_TYPES;

const { DIRECT_EXPORT } = CONTACT_EXPORT_TYPES;

let cancelMyleadsCall = null;

let cancelAPI = null;

function cancelPreviousAPI() {
  if (cancelMyleadsCall !== null) {
    cancelMyleadsCall('cancel');
    cancelMyleadsCall = null;
  }
  if (cancelAPI !== null) {
    cancelAPI('cancel');
    cancelAPI = null;
  }
}

class MyLeadsState {
  @observable leadsResults = [];

  @observable leadsResultCount = 0;

  @observable lastContactId = null;

  @observable lastContactUpdateTs = null;

  @observable firstContactId = null;

  @observable firstContactUpdateTs = null;

  @observable bulkPurchaseIds = [];

  @observable phoneNumberUpdated = {
    id: '',
    type: '',
  };

  @observable bulkSelectedIdForPurchase = [];

  @observable resultLoading = false;

  @observable allContactSelected = false;

  @observable actionLoader = false;

  @observable selectedList = {
    id: '',
    name: '',
  };

  @observable isPurchaseInProgress = false;

  currentTab = 0;

  @computed
  get getSelectedIds() {
    const ids = this.leadsResults.reduce((output, input) => {
      if (this.bulkPurchaseIds.includes(input.id))
        return [...output, input.memberContactId];
      return output;
    }, []);
    return ids;
  }

  @action
  setActionLoader(value) {
    this.actionLoader = value;
  }

  @action
  setPhoneNumberFlag = (value, id) => {
    this.phoneNumberUpdated = {
      id,
      type: value,
    };
  };

  @action
  setSelectedList(value) {
    this.selectedList = value;
  }

  @action
  updateSelectedBulkContactIds(index) {
    const obj = JSON.parse(JSON.stringify(this.leadsResults));
    if (index !== undefined) {
      const curObj = obj[index];
      if (!obj[index].checked) {
        this.bulkPurchaseIds.push(curObj.id);
      } else if (this.bulkPurchaseIds.includes(curObj.id)) {
        const ind = this.bulkPurchaseIds.indexOf(curObj.id);
        this.bulkPurchaseIds.splice(ind, 1);
      }
      obj[index].checked = !curObj.checked;
    }
    this.leadsResults = obj;
    this.checkIsAllContactSelected();
  }

  @action
  checkIsAllContactSelected() {
    const results = JSON.parse(JSON.stringify(this.leadsResults));
    let i = 0;
    results.map((item, index) => {
      // eslint-disable-next-line no-plusplus
      if (item.checked) i++;
      return true;
    });
    if (i === results.length) this.allContactSelected = true;
    else this.allContactSelected = false;
  }

  @action
  updateSelectedBulkContactAll(clearSelection) {
    const results = JSON.parse(JSON.stringify(this.leadsResults));

    const bulkIds = JSON.parse(JSON.stringify(this.bulkPurchaseIds));
    let newResults = [];
    if (this.allContactSelected || clearSelection) {
      newResults = results.map(item => {
        const newItem = item;
        newItem.checked = false;

        if (bulkIds.includes(item.id)) {
          const ind = bulkIds.indexOf(item.id);
          bulkIds.splice(ind, 1);
        }
        return newItem;
      });
      this.allContactSelected = false;
    } else {
      newResults = results.map(item => {
        const newItem = item;
        newItem.checked = true;

        if (!bulkIds.includes(item.id)) bulkIds.push(item.id);

        return newItem;
      });
      this.allContactSelected = true;
      this.leadsResults = newResults;
    }
    this.leadsResults = newResults;
    this.bulkPurchaseIds = bulkIds;
  }

  @action
  clearPreviouslySelectedConatcts() {
    this.bulkPurchaseIds = [];
    this.updateSelectedBulkContactAll(true);
  }

  getCurrentTabData() {
    const listId = this.selectedList.id;
    if ([1, 2, 3].includes(this.currentTab))
      this.myLeadsContactsInfo({
        type: this.currentTab,
        listId,
      });
    else
      this.getLeadsResults({
        listId,
      });
  }

  @action
  getLeadsResults(data) {
    const {
      listId,
      pagination,
      lastContactId,
      lastContactUpdateTs,
      pageLimit = 50,
    } = data;

    const currentListData =
      userDetail.myLeadList?.find(prop => prop.id === listId) ?? {};

    const config = {
      url: Utils.generateUrl(URLS.myList.getListContacts, {
        id: listId !== null && listId !== '' ? listId : 'all',
        limit: pageLimit,
        pagination,
        lastOwnedId: lastContactId,
        lastOwnedIdUpdateTs: lastContactUpdateTs,
        isSharedList: currentListData?.isSharedList || false,
        teamId: userDetail.userInfo?.teamId,
      }),
      method: 'GET',
    };
    if ((listId === '' || listId === null) && this.selectedList.id !== '') {
      this.selectedList.id = '';
      this.selectedList.name = 'All Leads';
    }
    const thisObj = this;

    this.clearPreviouslySelectedConatcts();

    cancelPreviousAPI();
    const cancelMyleadsCallBack = value => {
      cancelMyleadsCall = value;
    };
    this.resultLoading = true;
    makeApi(config, false, cancelMyleadsCallBack)
      .then(response => {
        if (response && response.message === undefined) {
          this.isPurchaseInProgress = Utils.isNotUndefinedNotNull(
            response.data.purchaseInProgress,
          )
            ? response.data.purchaseInProgress
            : false;
          if (currentListData?.count >= 0)
            this.leadsResultCount = currentListData?.count;

          if (response.data.list?.length > 0) {
            const listDetails = response.data.list;
            const results = listDetails.map(item => {
              const newObj = item;
              if (this.bulkPurchaseIds.includes(item.id)) newObj.checked = true;
              else newObj.checked = false;
              return newObj;
            });
            this.leadsResults = results;

            this.lastContactId = response.data.nextOwnedContactId;
            this.lastContactUpdateTs = response.data.nextOwnedContactIdUpdateTs;

            this.firstContactId = response.data?.prevOwnedContactId;
            this.firstContactUpdateTs =
              response.data?.prevOwnedContactIdUpdateTs;

            this.checkIsAllContactSelected();

            thisObj.resultLoading = false;
          } else {
            this.leadsResults = [];
            thisObj.resultLoading = false;
          }
        }
      })
      .catch(error => {
        this.resultLoading = false;
        console.log('suggestionList error ', error);
      });
  }

  @action
  createList = async data => {
    const config = {
      url: URLS.myList.list,
      method: 'POST',
      data: {
        name: data.name,
        isSharedList: data.isSharedList,
        teamId: userDetail.userInfo.teamId,
      },
    };

    const response = await makeApi(config);
    if (response?.data?.result === 'Error' || response?.status !== 200)
      toasterState.setToastMsg(
        response?.data?.responseMsg || 'List Creation failed',
      );
    return response;
  };

  @action
  renameLeadsList = (id, name, oldName, callback = () => {}) => {
    if (id !== undefined && name !== '') {
      const config = {
        url: Utils.generateUrl(URLS.myList.listUpdate, { id }),
        method: 'PATCH',
        data: {
          name,
        },
      };
      makeApi(config)
        .then(response => {
          console.log('renameLeadsList ', response);

          if (response?.data?.result === 'Success') {
            Utils.mixpanelTrack(CONSTANTS.MX_ML_EVENTS.ML_LIST_RENAMED, {
              newListName: name,
              oldListName: oldName,
            });
            callback('success');
            // loginValidate(true);
            userDetail.setMyLeadList(
              userDetail.myLeadList.map(list => {
                if (list.id === id) return { ...list, name };
                return list;
              }),
            );

            if (this.selectedList.id === id) this.selectedList.name = name;
          } else {
            callback('failed');
          }
        })
        .catch(error => {
          console.log('renameLeadsList error ', error);
          callback('failed');
        });
    }
  };

  @action
  deleteLeadsList = async (id, listName) => {
    if (id !== undefined) {
      const config = {
        url: Utils.generateUrl(URLS.myList.listUpdate, { id }),
        method: 'DELETE',
      };
      this.actionLoader = true;
      const response = await makeApi(config);
      this.actionLoader = false;
      if (response?.data?.result === 'Success') {
        toasterState.setToastMsg(
          'List deleted successfully',
          CONSTANTS.TOAST_MSG_TYPES.SUCCESS_NEW,
        );
        Utils.mixpanelTrack(CONSTANTS.MX_ML_EVENTS.ML_LIST_DELETED, {
          listName,
        });
        myLeadsList();
        return true;
      }
      toasterState.setToastMsg(
        'Failed to delete the list',
        CONSTANTS.TOAST_MSG_TYPES.FAILURE,
      );
      return false;
    }
    return false;
  };

  @action
  addToList = async data => {
    const { listId, listName, memberContactIds } = data;

    if (listId !== undefined) {
      const config = {
        url: Utils.generateUrl(URLS.myList.listContacts, { id: listId }),
        method: 'POST',
        data: {
          ids: memberContactIds,
        },
      };

      const response = await makeApi(config);
      const count = memberContactIds.length;
      if (response?.data?.result === 'Success') {
        toasterState.setToastMsg(
          `${count} contact${count > 1 ? 's' : ''} added to ${listName}`,
          CONSTANTS.TOAST_MSG_TYPES.SUCCESS_NEW,
        );
        userDetail.updateMyleadsListCount(response.data?.countByListId);
      } else {
        toasterState.setToastMsg(
          `Failed to add leads to the list ${listName}`,
          CONSTANTS.TOAST_MSG_TYPES.FAILURE,
        );
      }
    }
  };

  @action
  addToAnotherList = async (id, listName) => {
    this.actionLoader = true;

    await this.addToList({
      memberContactIds: this.getSelectedIds,
      listId: id,
      listName,
    });

    this.actionLoader = false;
    this.clearPreviouslySelectedConatcts();
    this.getCurrentTabData();
  };

  @action
  moveToAnotherList(listId, listName) {
    if (listId !== undefined) {
      const config = {
        url: Utils.generateUrl(URLS.myList.listContacts, {
          id: this.selectedList.id,
        }),
        method: 'PATCH',
        data: {
          listId,
          ids: this.getSelectedIds,
        },
      };
      this.actionLoader = true;
      makeApi(config)
        .then(response => {
          const count = this.bulkPurchaseIds.length;
          if (response?.data?.result === 'Success') {
            toasterState.setToastMsg(
              `${count} contact${count > 1 ? 's' : ''} moved to ${listName}`,
              CONSTANTS.TOAST_MSG_TYPES.SUCCESS_NEW,
            );
            userDetail.updateMyleadsListCount(response.data?.countByListId);
          } else {
            toasterState.setToastMsg(
              `Failed to move leads to list ${listName}`,
              CONSTANTS.TOAST_MSG_TYPES.FAILURE,
            );
          }
          this.actionLoader = false;
          this.clearPreviouslySelectedConatcts();
          this.getCurrentTabData();
        })
        .catch(error => {
          console.log('moveToAnotherList error ', error);
          this.actionLoader = false;
        });
    }
  }

  @action
  deleteFromList = async (listId, listName) => {
    if (listId !== undefined) {
      const config = {
        url: Utils.generateUrl(URLS.myList.listContacts, {
          id: this.selectedList.id,
        }),
        method: 'DELETE',
        data: {
          ids: this.getSelectedIds,
        },
      };
      this.actionLoader = true;
      const response = await makeApi(config);

      const count = this.bulkPurchaseIds.length;

      if (response?.data?.result === 'Success') {
        toasterState.setToastMsg(
          `${count} contact${
            count > 1 ? 's' : ''
          } has been deleted from ${listName}`,
          CONSTANTS.TOAST_MSG_TYPES.SUCCESS_NEW,
        );
        userDetail.updateMyleadsListCount(response.data?.countByListId);
      } else {
        toasterState.setToastMsg(
          `Failed to delete leads from list ${listName}`,
          CONSTANTS.TOAST_MSG_TYPES.FAILURE,
        );
      }
      this.actionLoader = false;
      this.getCurrentTabData();
    }
  };

  @action
  updateSearchResult = (newList = []) => {
    if (newList.length) {
      const updatedList = Utils.copyObjectWithoutReference(this.leadsResults);
      newList.map(item => {
        const newObj = item;
        newObj.checked = false;
        if (updatedList.findIndex(obj => obj.id === newObj.id) >= 0) {
          const ind = updatedList.findIndex(obj => obj.id === newObj.id);
          const searchObjData = updatedList[ind];
          searchObjData.email = newObj.email || null;
          searchObjData.phoneScoreEntity = newObj.phoneScoreEntity || null;
          searchObjData.owned = newObj.owned || false;
          searchObjData.emailValid = newObj.emailValid || false;
          updatedList[ind] = searchObjData;
        }
        return true;
      });
      this.leadsResults = updatedList;
    }
  };

  @action
  purchaseContactsForMyLeads(purchaseData) {
    const {
      ids = [],
      listId = this.selectedList.id,
      callback = null,
      type = DIRECT_PURCHASE,
      exportType,
    } = purchaseData;

    const contactIds = ids;
    const thisObj = this;
    const contactPurchaseCount = contactIds.length;
    const postData = {
      contactIds: JSON.stringify(ids),
      purchase_email: true,
      purchase_phone: false,
    };

    const url = Utils.generateUrl(URLS.purchaseContact, {
      type,
      ...(type === DIRECT_EXPORT && { exportType }),
      now: Date.now(),
      listId,
      ...(this.selectedList.id !== listId && {
        oldListId: this.selectedList.id,
      }),
      isEu: false,
      source: 'myLeads',
    });

    const config = {
      url,
      method: 'POST',
      data: postData,
    };

    makeApi(config)
      .then(async response => {
        const { data } = response;
        const { status = 'failure' } = data || {};
        if (callback !== null) callback(status);
        this.clearPreviouslySelectedConatcts();
        if (status === 'success') {
          Utils.mixpanelTrack(MX_ML_EVENTS.ML_JOB_CHANGE_PURCHASED, {
            contactIds: ids,
            type,
            exportType,
          });
          this.leadsResults = Utils.copyObjectWithoutReference(
            this.leadsResults,
          ).map(contact => {
            if (ids.includes(contact.id))
              return {
                ...contact,
                owned: true,
              };
            return contact;
          });
          const {
            totalCount,
            newlyAddedCount,
            successCount,
            contactViews,
            isCreditLimitExhausted = false,
          } = data || {};
          this.updateSearchResult(contactViews);
          if (ids.length === 1) {
            if (exportType === 'CSV') Utils.downloadToCsv(data);
            purchaseStatusPopupState.setToastMsg(
              newlyAddedCount,
              null,
              successCount,
            );
          } else {
            advSearchState.setSyncPurchaseOrExportData({
              type: 'ADD_TO_LIST',
              totalCount,
              newlyAddedCount,
              successCount,
              isZbEnabled: Utils.isZeroBounceEnabled(),
              isCreditLimitExhausted,
            });
          }
          loginValidate(true);
        } else {
          const { message = '', errorType = '' } = data || {};

          if (
            errorType &&
            (errorType === 'subscription' || errorType === 'creditLimit')
          ) {
            const mxData = {
              noContacts: contactPurchaseCount,
              DIRECT_PURCHASE,
              mobileWaterfall: Utils.isMobileWaterFallEnabled(),
            };
            Utils.mixpanelTrack(MX_ML_EVENTS.ML_VIEWS_EXPIRED, mxData);
            Utils.mixpanelTrack(MX_ML_EVENTS.ML_PAYWALL_PRICING_POPUP, mxData);
            if (errorType === 'creditLimit') Utils.showCreditExpiredPopup();
            else Utils.showUserPricingPopup(true, 'views', true);
          } else {
            advSearchState.setAsyncPurchaseOrExportMsg('UNKNOWN_ERROR');
          }
        }
        return this.leadsResults;
      })
      .catch(error => {
        thisObj.setActionLoader(false);
        // for the purpose of single contact loader
        console.error('purchase failed', error);
      });
  }

  @action
  myLeadsContactsInfo(data) {
    const { type, listId, page = 1, limit = 50, days } = data;
    const today = new Date();
    const dateFilter = days
      ? new Date(
          new Date().setDate(
            today.getDate() - parseInt(days.split('D')[0], 10),
          ),
        ).getTime()
      : undefined;
    const url = Utils.generateUrl(URLS.myLeadsContactsInfo, {
      type,
      listId,
      dateFilter,
      page,
      limit,
    });
    const config = {
      url,
      method: 'GET',
    };
    this.resultLoading = true;
    cancelPreviousAPI();
    const cancelUpdateContactsAPI = value => {
      cancelAPI = value;
    };
    makeApi(config, false, cancelUpdateContactsAPI)
      .then(response => {
        if (response.data?.totalContacts !== undefined) {
          this.clearPreviouslySelectedConatcts();
          this.leadsResultCount = response.data.totalContacts;
          const obj =
            response.data.contactDetails !== undefined &&
            response.data.contactDetails !== null
              ? JSON.parse(JSON.stringify(response.data.contactDetails))
              : [];

          if ([2, 3].includes(type))
            for (let i = 0; i < obj.length; i += 1)
              if (obj[i].diff) {
                const {
                  title,
                  linkedInURL,
                  city,
                  state,
                  country,
                  phoneCompany,
                  phoneMobile,
                  phoneOther,
                  phoneDirect,
                } = obj[i]?.diff;

                let updatesCount = 0;

                if (title) updatesCount += 1;
                if (linkedInURL) updatesCount += 1;
                if (city || country || state) updatesCount += 1;
                if (phoneCompany) updatesCount += 1;
                if (phoneMobile) updatesCount += 1;
                if (phoneOther) updatesCount += 1;
                if (phoneDirect) updatesCount += 1;

                if (updatesCount > 3) obj[i].allUpdatedFlag = true;
                else obj[i].allUpdatedFlag = false;
                obj[i].updatesCount = updatesCount;
              }
          this.leadsResults = obj;
          this.resultLoading = false;
        }
      })
      .catch(error => {
        console.log('Get contact update error ', error);
        this.resultLoading = false;
      });
  }
}

const myLeadsState = new MyLeadsState();

export { myLeadsState, cancelPreviousAPI };
export default myLeadsState;
